module.exports = __webpack_public_path__ + "img/H003_R_home slider.746b97a4.jpg";